import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import App from "../components/appStartkit";

import InternLinks from "../components/internlinks";
import { Breadcrumb } from "../components/globals/breadcrumb";

const IndexPage = () => (
  <Layout>
      <Breadcrumb category={["metoder", "metoder"]}  page={["Tandblekningsgel", "tandblekningsgel"]}/>
     <SEO title="Tandblekningsgel" description="Recension av Tandblekningsgel" />
    <main className="section-info">
    <section>
    <h1 class="welcome">Tandblekningsgel</h1>
    <p className="text-center">
      Den absolut vanligaste metoden för att få vita tänder hemma är tandblekningsgel. Redan efter ett par 
      blekningar ser man resultat och vitare tänder.</p>
      <p className="text-center">När man köper tandblekningsgel(startkit) så får man med en skena, gel och instruktioner.
      Enkelt förklarat så värmer man upp skenan och gör en prototyp som passar dina tänder. När du fått en bra modell, så 
      fylls den med gel och sedan pressar man på den på tänderna igen. Gelen kommer då åt emellan dina tänder och det blir 
      ett jämnt vitt resultat.</p>
      <p className="text-center">
      Det finns lite olika smaker på gelen, men det vanligaste är mint. Efter 4-5 tillfällen kan man kanske se resultat. 
      </p>
    </section>
  </main>
  <section className="section-cards">
  <main className="card__ai">
     <h2 class="card-rubrik">Startkit</h2>
     <h3 class="card__smRubrik">Bästa tandblekningen hemma</h3>
    <App />
    </main>
  </section>
  {/* <section className="section-faq">
    <FAQ />
  </section> */}
  <main className="section-info">
    <section>
    <h3 class="welcome">Vitare tänder</h3>
    <p className="text-center">
      Dina tänder kommer absolut bli vitare av att tandbleka hemma med gel. Dock beror resultatet på... Hur dina tänder såg ut innan och 
      vilka gener man har så kan resulten vara olika från person till person.</p>
      <p className="text-center">Är det först gången du bleker tänderna, så är det bra att göra det med gel. Det blir bäst resultat. Har 
      man sedan gjort det, kan man enkelt köpa refill gel. Eller efter det sköta om sina tänder med <a href="/strips">strips</a> 
      , <a href="/tandblekningspenna">tandblekningspenna</a> eller <a href="/tandkram">tandkräm</a>.</p>
      <ul class="ul-main">
        <li>Billigt</li>
        <li>Enkelt</li>
        <li>Vita tänder</li>
      </ul>
    </section>
  </main>
  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  </Layout>
)

export default IndexPage
